<div class="container border rounded pt-4 pb-2">
	<div class="row text-center mb-4">
		<span class="theme-main-color fw-bold fs-4"> Distance parcourue </span>
	</div>
	<div class="row my-2">
		<div class="col">
			<table class="table mt-3 theme-main-color">
				<caption>
					Distance parcourue
				</caption>
				<thead>
					<tr>
						<th scope="col">#</th>
						<th scope="col">Moyenne (km)</th>
						<th scope="col">Min. (km)</th>
						<th scope="col">Max. (km)</th>
					</tr>
				</thead>
				<tbody *ngIf="isSESSAD">
					<tr *ngIf="lpcStats?.nombrePlanning > 0">
						<th scope="row">LPC</th>
						<td>
							{{
								lpcStats?.beanParametreStatistiqueDistance.distanceMoyenne /
									1000 | number: '1.2-2'
							}}
						</td>
						<td>
							{{
								lpcStats?.beanParametreStatistiqueDistance.distanceMin / 1000
									| number: '1.2-2'
							}}
						</td>
						<td>
							{{
								lpcStats?.beanParametreStatistiqueDistance.distanceMax / 1000
									| number: '1.2-2'
							}}
						</td>
					</tr>
					<tr *ngIf="lsfStats?.nombrePlanning > 0">
						<th scope="row">LSF</th>
						<td>
							{{
								lsfStats?.beanParametreStatistiqueDistance.distanceMoyenne /
									1000 | number: '1.2-2'
							}}
						</td>
						<td>
							{{
								lsfStats?.beanParametreStatistiqueDistance.distanceMin / 1000
									| number: '1.2-2'
							}}
						</td>
						<td>
							{{
								lsfStats?.beanParametreStatistiqueDistance.distanceMax / 1000
									| number: '1.2-2'
							}}
						</td>
					</tr>
					<tr *ngIf="pdnStats?.nombrePlanning > 0">
						<th scope="row">PDN</th>
						<td>
							{{
								pdnStats?.beanParametreStatistiqueDistance.distanceMoyenne /
									1000 | number: '1.2-2'
							}}
						</td>
						<td>
							{{
								pdnStats?.beanParametreStatistiqueDistance.distanceMin / 1000
									| number: '1.2-2'
							}}
						</td>
						<td>
							{{
								pdnStats?.beanParametreStatistiqueDistance.distanceMax / 1000
									| number: '1.2-2'
							}}
						</td>
					</tr>
				</tbody>
				<tbody *ngIf="isSAAD">
					<tr *ngIf="globalStats?.nombrePlanning > 0">
						<th scope="row">Aide à domicile</th>
						<td>
							{{
								globalStats?.beanParametreStatistiqueDistance.distanceMoyenne /
									1000 | number: '1.2-2'
							}}
						</td>
						<td>
							{{
								globalStats?.beanParametreStatistiqueDistance.distanceMin / 1000
									| number: '1.2-2'
							}}
						</td>
						<td>
							{{
								globalStats?.beanParametreStatistiqueDistance.distanceMax / 1000
									| number: '1.2-2'
							}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="col-4 min-height-charts">
			<div echarts [options]="option"></div>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<div class="col">
				<div class="row">
					<div class="col text-center">
						<span class="theme-main-color fw-bold fs-4"> Dispersion </span>
					</div>
				</div>
				<app-travel-distance-dispersion
					*ngIf="isSESSAD"
					[statistiquesDistance]="[
						lpcStats?.beanParametreStatistiqueDistance,
						lsfStats?.beanParametreStatistiqueDistance,
						pdnStats?.beanParametreStatistiqueDistance
					]"
					[categorie]="categorie"
				></app-travel-distance-dispersion>
				<app-travel-distance-dispersion
					*ngIf="isSAAD"
					[statistiquesDistance]="[
						globalStats?.beanParametreStatistiqueDistance
					]"
					[categorie]="categorie"
				></app-travel-distance-dispersion>
			</div>
		</div>
	</div>
</div>
